import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DateSelectorWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const GuideArea = styled.div(() =>
  mq({
    display: 'flex',
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    margin: [
      `0 0 ${defaultTheme.spacing.l} 0`,
      `0 0 ${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
    ],
    justifyContent: 'flex-end',
  }),
);

export const CancelColor = styled.div(() =>
  mq({
    width: ['12px', '12px', '16px', '16px'],
    height: ['12px', '12px', '16px', '16px'],
    backgroundColor: defaultTheme.background.mediumGray,
    marginRight: defaultTheme.spacing.s,
  }),
);

export const Content = styled.div(() =>
  mq({
    display: 'grid',
    gap: '32px',
  }),
);

export const TableTitle = styled.div(() =>
  mq({
    fontWeight: 'bold',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const TableWrapper = styled.div(() =>
  mq({
    width: [
      'calc(100vw - 32px)',
      'calc(100vw - 32px)',
      'calc(100vw - 128px)',
      'calc(100vw - 128px)',
      '100%',
    ],
    minWidth: 'calc(320px - 128px)',
    overflow: ['hidden', 'hidden', 'hidden', 'hidden', 'inherit'],
    overflowX: ['scroll', 'scroll', 'scroll', 'scroll', 'inherit'],
  }),
);

export const Table = styled.table(() =>
  mq({
    height: '1px',
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0',
    '& > thead, tbody': {
      height: '100%',
      '& > tr': {
        height: '100%',
      },
    },
  }),
);

export const StyledTh = styled.th(() =>
  mq({
    minWidth: ['82px', '82px', '100px', '100px'],
    height: '100%',
    borderRight: `1px solid ${defaultTheme.border.color.black}`,
    borderBottom: `1px solid ${defaultTheme.border.color.black}`,
    position: ['sticky', 'sticky', 'sticky', 'sticky', 'inherit'],
    left: '0',
  }),
);

export const TableHeadTitle = styled(StyledTh)(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    borderTop: `1px solid ${defaultTheme.border.color.black}`,
    padding: `${defaultTheme.spacing.s} ${defaultTheme.spacing.l}`,
    verticalAlign: 'bottom',
  }),
);

export const TableBodyTitle = styled(StyledTh)(() =>
  mq({
    padding: `${defaultTheme.spacing.l}`,
    backgroundColor: defaultTheme.background.mediumLightGray,
    verticalAlign: 'middle',
  }),
);

export const Note = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    color: defaultTheme.color.grayScale.dark,
    marginTop: defaultTheme.spacing.l,
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gap: defaultTheme.spacing.xs,
    rowGap: defaultTheme.spacing.s,
  }),
);
